import React from "react"
import {Button, Form, Input} from "antd"

type Props = {
  onSubmit: (phoneNumber: string) => void
}

type PhoneNumberFormData = {
  phoneNumber: string
}

export const SetPhoneNumberForm: React.FC<Props> = ({
  onSubmit,
}) => {
  const [form] = Form.useForm<PhoneNumberFormData>()
  return <Form form={form} onFinish={({phoneNumber}) => onSubmit(phoneNumber)}>
    <Form.Item
      name="phoneNumber"
      label="New Phone Number"
      rules={[
        {required: true, message: "Please input your phone number!"},
      ]}
    >
      <Input/>
    </Form.Item>
    <Form.Item>
      <Button type="primary" htmlType="submit">
        Update
      </Button>
    </Form.Item>
  </Form>
}